import React, { useEffect, useState } from 'react';
import { Grid, Button, makeStyles } from '@material-ui/core';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import WorkstationTile from '../../Workstation/WorkstationTile';
import { useHistory } from 'react-router-dom';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { machine } from '../../../Config/constants';
import { connect } from 'react-redux';

export const WorkstationOverviewPage = (props) => {

    const classes = useStyles();
    const [activeWorkstationIds, setActiveWorkstationIds] = useState([])
    const [workstations, setWorkstations] = useState([])
    const { t } = useTranslation();
    let history = useHistory();

    useEffect(() => {
        dataService.getMachinesByMachineType(machine).then(stations => {
            if (JSON.stringify(stations) !== JSON.stringify(workstations)) {
                setWorkstations(stations)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getMachinesWithScissorStatusInfo().then(workstationsWithScissorStatusses => {

            if (JSON.stringify(props.workstationState.workstationsWithScissorStatusInfo) !== JSON.stringify(workstationsWithScissorStatusses.sort((a, b) => a.id - b.id))) {
                props.actions.setWorkstationWithScissorStatusInfo(workstationsWithScissorStatusses.sort((a, b) => a.id - b.id))
            }

            let workstationIds = []
            var i;
            if (!props.workstation.noSelectedWorkstation) {
                if (props.workstation.activeWorkstations) {
                    for (i = 0; i < props.workstation.activeWorkstations.length; i++) {
                        workstationIds.push(props.workstation.activeWorkstations[i].id)
                    }
                }
            }

            setActiveWorkstationIds(workstationIds)

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }, [props.workstation.activeWorkstations]);

    function activateWorkstation(workstationId) {
        let tempActiveWorkstations = Object.assign([], activeWorkstationIds);
        if (tempActiveWorkstations.some(x => x === workstationId)) {
            let index = tempActiveWorkstations.indexOf(tempActiveWorkstations.find(x => x === workstationId))
            tempActiveWorkstations.splice(index, 1)
            setActiveWorkstationIds(tempActiveWorkstations)
        }
        else {
            tempActiveWorkstations.push(workstationId)
            setActiveWorkstationIds(tempActiveWorkstations)
        }
    }

    function showPlanning() {
        let min = 0
        if (activeWorkstationIds.length === 0) {
            if (props.user.isAdministrator || props.user.isPloegchef) {
                props.actions.setActiveWorkstations(workstations)
                min = workstations[0].id
                props.actions.setNoSelectedWorkstation(true)
            }
            else {
                props.actions.setActiveWorkstations([])
            }
        }
        else {
            let activeWorkstations = workstations.filter(x => activeWorkstationIds.some(y => y === x.id))
            props.actions.setActiveWorkstations(activeWorkstations)
            min = Math.min(...activeWorkstationIds)
            props.actions.setNoSelectedWorkstation(false)
        }
        props.actions.setSelectedWorkstation(min)
        history.push("/workstation")
    }



    return (
        <div className={classes.background}>
            <div className={classes.spacer80}>
                {t("Workstations")}
            </div>
            <Grid container spacing={2} className={classes.gridContainer}>
                {props.workstationState.workstationsWithScissorStatusInfo && workstations ?
                    props.workstationState.workstationsWithScissorStatusInfo.map((workstation) => (
                        <Grid className={classes.gridmargin}  key={workstation.id} item>
                            <WorkstationTile {...props}  activeWorkstationIds={activeWorkstationIds} workstation={workstation} activateWorkstation={activateWorkstation} active={activeWorkstationIds.some(x => x === workstation.id)}></WorkstationTile>
                        </Grid>
                    )) : <React.Fragment></React.Fragment>}

            </Grid>
            <div className={classes.buttonContainer}>
                <Button disabled={activeWorkstationIds.length === 0 ? true : false} className={classes.startProductionButton} onClick={showPlanning}>{t("SHOW PLANNING")}</Button>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px',
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        paddingLeft: "20px"
    },
    gridmargin: {

    },
    gridContainer: {
        display: "flex",
        justifyContent: "center",
    },
    navButton: {
        textDecoration: 'none'
    },
    background: {
        width: '100%',
        position: "relative",
        top: "60px",

    },
    startProductionButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "200px",
        height: "40px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
    },
    buttonContainer: {
        width: "100%",
        textAlign: "center",
        marginTop: "50px"
    }
});

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState,
        general:state.general
    }
}

export default connect(mapStateToProps)(WorkstationOverviewPage)